import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function CustomTabs(props) {
  const { children, onTabChange, disabled } = props;
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const handleChange = (id, newValue) => {
    setValue(newValue);
    onTabChange(id, newValue);
  };

  return (
    <Box sx={{ width: "100%", backgroundColor: "#06224F" }}>
      <Tabs
        allowScrollButtonsMobile
        aria-label="mstr dossier tabs"
        className="custom-tabs"
        disabled={disabled}
        scrollButtons="auto"
        sx={{
          backgroundColor: "#06224F",
          minHeight: "34px",
          maxWidth: "100%",
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }}
        variant="scrollable"
        value={value}
        onChange={(x, t) => {
          handleChange(children[t].props.did, t);
        }}
      >
        {children.map((child, index) => {
          const isSelected = index === value;

          return (
            <Tab
              key={child.props.did || index}
              disabled={disabled}
              label={child.props.tabName}
              sx={{
                color: isSelected ? "#0b9f3f !important" : "white",
                backgroundColor: isSelected ? "#f0f0f0" : "transparent",
                textTransform: "none",
                fontWeight: theme.typography.fontWeightRegular,
                "&.Mui-selected": {
                  fontWeight: theme.typography.fontWeightMedium,
                },
                minWidth: { xs: "108px", sm: "132px" },
                minHeight: "28px",
                lineHeight: 1,
                fontSize: theme.typography.pxToRem(14),
                marginTop: "4px",
                borderTopLeftRadius: "2px",
                borderTopRightRadius: "2px",
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}

export default CustomTabs;
